import { render, staticRenderFns } from "./CategoryPreview.vue?vue&type=template&id=4029e268&"
import script from "./CategoryPreview.vue?vue&type=script&lang=js&"
export * from "./CategoryPreview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports